var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigure2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 369,
    viewBox: "0 0 415 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.242 0H103.747L0 184.458L103.747 368.885H311.242L414.99 184.458L311.242 0ZM271.114 297.574H143.866L80.2464 184.458L143.866 71.3312H271.114L334.743 184.458L271.114 297.574Z",
    fill: "#F9F9F9",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure2);
export default __webpack_public_path__ + "static/media/figure2.9f39e66f5594cde15acc56080dffdba9.svg";
export { ForwardRef as ReactComponent };